import React, { useContext, useEffect, useState } from "react"
import BoxComponent from "../../../components/Box/BoxComponent";
import { styleSections } from "./styles";
import CatalogoAdminCategorias from "./components/CatalogoAdminCategorias";
import CatalogoAdminPrincipal from "./components/CatalogoAdminPrincipal";
import CatalogoAdminComplementos from "./components/CatalogoAdminComplementos";
import { CatalogoCategoria, ItemCategoria } from "../../../interface/item/categoria/ItemCategoria";
import { catalogoService } from "../../../service/CatalogoService";
import { EmpresaContext } from "../../../provider/empresa/EmpresaContext";
import { CatalogoComplemento, CatalogoOpcao, ItemDestaque } from "../public/CatalogoPage";
import { AuthContext } from "../../../provider/auth/AuthContext";

const CatalogoAdminPage = () => {
    const { empresa } = useContext(EmpresaContext);
    const { token } = useContext(AuthContext);

    const [categoriaSelecionada, setCategoriaSelecionada] = useState<ItemCategoria>();

    /* HANDLERS */
    const handleClickCategoria = (item: ItemCategoria) => {
        setCategoriaSelecionada(item);
    }

    const [isClickedEdicaoCategoria, setIsClickedEdicaoCategoria] = useState<boolean>(false);
    const handleClickEditCategoria = (categoria: CatalogoCategoria) => {
        alert("Alterando categoria " + categoria.id)
        setIsClickedEdicaoCategoria(true);
    }

    const [isClickedExclusaoCategoria, setIsClickedExclusaoCategoria] = useState<boolean>(false);
    const handleClickDeleteCategoria = (categoria: CatalogoCategoria) => {
        alert("Deletando categoria " + categoria.id);
        setIsClickedExclusaoCategoria(true);
    }

    // const handleClickNovoComplemento = () => {
    //     alert("estou criando um novo complemento");
    // }

    // const handleClickComplemento = (complemento: CatalogoComplemento) => {
    //     alert(`Cliquei no complemento #${complemento.id}`);
    // }

    // const handleClickInativarComplemento = (complemento: CatalogoComplemento) => {
    //     alert(`Cliquei para EXCLUIR complemento #${complemento.id}`);
    // }

    // const handleClickNovaOpcao = () => {
    //     alert("estou criando uma nova opção");
    // }

    // const handleClickOpcao = (opcao: CatalogoOpcao) => {
    //     alert(`Cliquei na opção #${opcao.id}`);

    // }

    // const handleClickInativarOpcao = (opcao: CatalogoOpcao) => {
    //     alert(`Cliquei para EXCLUIR opção #${opcao.id}`);
    // }

    /* CONSULTAS */
    const [categorias, setCategorias] = useState<ItemCategoria[]>([]);
    const getCategorias = async (id: number, token: string) => {
        try {
            const categoriasApi = await catalogoService.getCategoriasAdmin(id, token);
            setCategorias(categoriasApi);
        } catch (e) {
            console.error(e);
        }
    }

    const [itensCategoria, setItensCategoria] = useState<ItemDestaque[]>([]);
    const getItensCategorias = async (id: number, token: string) => {
        if (categoriaSelecionada) {
            try {
                const data = await catalogoService.getCatalogoAdmin(id, token, categoriaSelecionada.value);
                setItensCategoria(data);
            } catch (e) {
                console.error(e);
            }
        }
    }

    const [complementos, setComplementos] = useState<CatalogoComplemento[]>([]);
    const getComplementos = async (id: number, token: string) => {
        if (categoriaSelecionada) {
            try {
                const data = await catalogoService.getComplementosAdmin(id, categoriaSelecionada.id, token);
                setComplementos(data);
            } catch (e) {
                console.error(e);
            }
        }
    }

    const [opcoes, setOpcoes] = useState<CatalogoOpcao[]>([]);
    const getOpcoes = async (id: number, token: string) => {
        if (categoriaSelecionada) {
            try {
                const data = await catalogoService.getOpcoesAdmin(id, categoriaSelecionada.id, token);
                setOpcoes(data);
            } catch (e) {
                console.error(e);
            }
        }
    }

    /* RENDERIZAÇÕES */
    const renderCategorias = () => {
        return <CatalogoAdminCategorias
            categorias={categorias}
            categoriaSelecionada={categoriaSelecionada}
            onChangeCategoriaSelecionada={(categoria: ItemCategoria) => handleClickCategoria(categoria)}
            onClickEditarCategoria={handleClickEditCategoria}
            onClickDeleteCategoria={handleClickDeleteCategoria}
        />
    }

    const renderCatalogo = () => {
        return <CatalogoAdminPrincipal
            itensCategoria={itensCategoria}
            categoriaSelecionada={categoriaSelecionada}
            idEmpresa={empresa?.id}
            token={token}
            updateCategorias={() => {
                if (empresa?.id && token) getCategorias(empresa.id, token);
            }}
            updateItens={() => {
                if (empresa?.id && token) getItensCategorias(empresa.id, token);
            }}
        />
    }

    const [tab, setTab] = useState<number>(0);
    const renderComplementos = () => {
        return <CatalogoAdminComplementos
            tab={tab}
            onChangeTab={(number: number) => setTab(number)}
            idCategoria={categoriaSelecionada?.id}
            idEmpresa={empresa?.id || 0}
            token={token}

            complementos={complementos}
            updateComplementos={() => getComplementos(empresa?.id!, token!)}

            opcoes={opcoes}
            updateOpcoes={() => getOpcoes(empresa?.id!, token!)}
        />
    }

    /* effect */
    useEffect(() => {
        if (empresa && token) {
            getCategorias(empresa.id, token);
        }
    }, [empresa?.id]);

    useEffect(() => {
        if (empresa && token) {
            getItensCategorias(empresa.id, token);
            getComplementos(empresa.id, token);
            getOpcoes(empresa.id, token);
        }
    }, [categoriaSelecionada]);

    return <>
        <BoxComponent
            component="div"
            sx={{
                display: "flex",
                gap: 2,
                height: "100%"
            }}
        >
            {/* SECAO DAS CATEGORIAS */}
            <BoxComponent
                component="section"
                sx={{
                    ...styleSections,
                    width: "192px",
                }}
            >
                {renderCategorias()}
            </BoxComponent>

            {/* SECAO DO CATALOGO EM SI */}
            <BoxComponent
                component="section"
                sx={{
                    ...styleSections,
                    border: 0,
                    backgroundColor: "transparent",
                    flex: 1,
                    gap: 2
                    // width: "1150px"
                }}
            >
                {renderCatalogo()}
            </BoxComponent>

            {/* SECAO DOS COMPLEMENTOS */}
            {categoriaSelecionada && (
                <BoxComponent
                    component="section"
                    sx={{
                        ...styleSections,
                        width: "256px"
                    }}
                >
                    {renderComplementos()}
                </BoxComponent>
            )}

        </BoxComponent>
    </>
}

export default CatalogoAdminPage;